import React from 'react'
import styled, {css} from 'styled-components'

import Input from '@/components/input/input'
import {Text} from '@/components/text'
import {colors, radii, tokens} from '@/theme'
import mq from '@/utils/media-query'

export const formsPadding = css`
    padding: ${tokens.spacing24};

    ${mq.min('md')} {
        padding: ${tokens.spacing40};
    }
`

export const StyledBackgroundWrapper = styled.div`
    ${formsPadding}
    background: ${colors.background.muted};
    border-radius: ${radii.arc20};
`

export const StyledInput = styled(Input)`
    background-color: ${colors.background.default};
`

export const ReadOnlyInput = styled(Input)`
    border-color: ${colors.border.secondary};
`

interface Props {
    title?: string
    style?: React.CSSProperties
    className?: string
    children: React.ReactNode
}

export const SectionWrapper = ({title, children, style, className}: Props) => (
    <Wrapper>
        {title && <StyledText $variant="paragraph-large-medium">{title}</StyledText>}

        <div style={style} className={className}>
            {children}
        </div>
    </Wrapper>
)

const StyledText = styled(Text)`
    margin-bottom: ${tokens.spacing20};

    ${mq.min('sm')} {
        margin-bottom: ${tokens.spacing32};
    }
`

const Wrapper = styled.div`
    ${formsPadding}
    background-color: ${colors.background.muted};
    border-radius: ${radii.arc20};
`
